import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FoxLogo } from './FoxLogo';
import { LayoutDashboard, Server, CreditCard, LifeBuoy, Settings, LogOut, Users, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface SidebarProps {
  type: 'customer' | 'business';
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
export function DashboardSidebar({
  type,
  isOpen,
  setIsOpen
}: SidebarProps) {
  const navigate = useNavigate();
  const customerLinks = [{
    name: 'Overview',
    path: '/dashboard/customer',
    icon: LayoutDashboard
  }, {
    name: 'My Services',
    path: '/dashboard/customer/services',
    icon: Server
  }, {
    name: 'Billing',
    path: '/dashboard/customer/billing',
    icon: CreditCard
  }, {
    name: 'Support',
    path: '/dashboard/customer/support',
    icon: LifeBuoy
  }, {
    name: 'Settings',
    path: '/dashboard/customer/settings',
    icon: Settings
  }];
  const businessLinks = [{
    name: 'Overview',
    path: '/dashboard/business',
    icon: LayoutDashboard
  }, {
    name: 'Services & Products',
    path: '/dashboard/business/services',
    icon: Server
  }, {
    name: 'Team',
    path: '/dashboard/business/team',
    icon: Users
  }, {
    name: 'Billing',
    path: '/dashboard/business/billing',
    icon: CreditCard
  }, {
    name: 'Support',
    path: '/dashboard/business/support',
    icon: LifeBuoy
  }, {
    name: 'Settings',
    path: '/dashboard/business/settings',
    icon: Settings
  }];
  const links = type === 'customer' ? customerLinks : businessLinks;
  const handleLogout = () => {
    navigate('/login');
  };
  const SidebarContent = () => <div className="flex flex-col h-full bg-slate-950 border-r border-slate-800 w-64" data-id="element-1641">
      <div className="p-6 flex items-center gap-3 border-b border-slate-800" data-id="element-1642">
        <FoxLogo className="w-8 h-8" data-id="element-1643" />
        <div data-id="element-1644">
          <h2 className="font-heading font-bold text-white leading-tight" data-id="element-1645">
            Fox Line
          </h2>
          <span className="text-xs text-fox-500 font-medium uppercase tracking-wider" data-id="element-1646">
            {type} Portal
          </span>
        </div>
      </div>

      <div className="flex-1 py-6 px-4 overflow-y-auto" data-id="element-1647">
        <nav className="space-y-1" data-id="element-1648">
          {links.map(link => <NavLink key={link.name} to={link.path} end={link.path === `/dashboard/${type}`} onClick={() => setIsOpen(false)} className={({
          isActive
        }) => `
                flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors
                ${isActive ? 'bg-fox-600/10 text-fox-500 border border-fox-500/20' : 'text-slate-400 hover:text-white hover:bg-slate-900'}
              `} data-id="element-1649">
              <link.icon size={18} data-id="element-1650" />
              {link.name}
            </NavLink>)}
        </nav>
      </div>

      <div className="p-4 border-t border-slate-800" data-id="element-1651">
        <button onClick={handleLogout} className="flex items-center gap-3 px-4 py-3 w-full rounded-xl text-sm font-medium text-slate-400 hover:text-white hover:bg-slate-900 transition-colors" data-id="element-1652">
          <LogOut size={18} data-id="element-1653" />
          Sign Out
        </button>
      </div>
    </div>;
  return <>
      {/* Mobile Toggle */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-slate-950 border-b border-slate-800 z-40 flex items-center justify-between px-4" data-id="element-1654">
        <div className="flex items-center gap-2" data-id="element-1655">
          <FoxLogo className="w-6 h-6" data-id="element-1656" />
          <span className="font-heading font-bold text-white" data-id="element-1657">Portal</span>
        </div>
        <button onClick={() => setIsOpen(!isOpen)} className="text-slate-300 hover:text-white" data-id="element-1658">
          {isOpen ? <X size={24} data-id="element-1659" /> : <Menu size={24} data-id="element-1660" />}
        </button>
      </div>

      {/* Desktop Sidebar */}
      <div className="hidden lg:block fixed top-0 left-0 h-screen z-30" data-id="element-1661">
        <SidebarContent data-id="element-1662" />
      </div>

      {/* Mobile Sidebar Overlay */}
      <AnimatePresence data-id="element-1663">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsOpen(false)} className="lg:hidden fixed inset-0 bg-black/60 backdrop-blur-sm z-40" data-id="element-1664" />
            <motion.div initial={{
          x: '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '-100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="lg:hidden fixed top-0 left-0 h-screen z-50" data-id="element-1665">
              <SidebarContent data-id="element-1666" />
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}